const mockRecSessions = [
    {
        id: 'rec_01',
        label: '1m1',
        title: 'Rec1',
        timecode: '00:01:12',
        date: '2026-01-11 14:30:00.000',
        coreLayer: {
            tracks: [
                {
                    id: 'core_01_track_01',
                    title: 'Theme 01',
                    timecode: '00:00:00:00',
                    instanceDuration: { parsedValue: 120000 },
                    startPlayback: { parsedValue: 0 },
                    priority: { parsedValue: 0 },
                    clip: {
                        id: 'clip_01',
                        name: 'theme_01.mp3',
                        duration: 120000,
                        url: '/audio/theme_01.mp3'
                    }
                }
            ]
        },
        auxLayers: []
    },
    {
        id: 'rec_02',
        label: '1m2',
        title: 'Rec2',
        timecode: '00:00:03',
        date: '2026-01-14 14:30:00.000',
        coreLayer: {
            tracks: [
                {
                    id: 'core_02_track_01',
                    title: 'Traccia Musiche',
                    timecode: '00:00:00:00',
                    instanceDuration: { parsedValue: 180000 },
                    startPlayback: { parsedValue: 0 },
                    priority: { parsedValue: 0 },
                    clip: {
                        id: 'clip_02',
                        name: 'Traccia Musiche.mp3',
                        duration: 180000,
                        url: '/audio/Traccia Musiche.mp3'
                    }
                }
            ]
        },
        auxLayers: [
            {
                id: 'aux_02_01',
                sessionType: 'PIANO',
                assignedUser: null,
                volume: 80,
                tracks: [
                    {
                        id: 'aux_02_01_track_01',
                        title: 'Piano Take 1',
                        timecode: '00:00:00:00',
                        instanceDuration: { parsedValue: 9000 },
                        startPlayback: { parsedValue: 0 },
                        priority: { parsedValue: 0 },
                        clip: {
                            id: 'clip_03',
                            name: 'sample-9s.mp3',
                            duration: 9000,
                            url: '/audio/sample-9s.mp3'
                        }
                    }
                ]
            },
            {
                id: 'aux_02_02',
                sessionType: 'STRINGS',
                assignedUser: { userId: 'user_mock_02', name: 'Giulia', surname: 'Bianchi', profile_picture_url: null },
                volume: 90,
                tracks: [
                    {
                        id: 'aux_02_02_track_01',
                        title: 'Orchestra Take 1',
                        timecode: '00:00:03:00',
                        instanceDuration: { parsedValue: 3000 },
                        startPlayback: { parsedValue: 0 },
                        priority: { parsedValue: 0 },
                        clip: {
                            id: 'clip_04',
                            name: 'sample-3s.mp3',
                            duration: 3000,
                            url: '/audio/sample-3s.mp3'
                        }
                    }
                ]
            }
        ]
    },
    {
        id: 'rec_03',
        label: '1m3',
        title: 'Rec3',
        timecode: '00:00:09',
        date: '2026-01-15 14:30:00.000',
        coreLayer: {
            tracks: [
                {
                    id: 'core_03_track_01',
                    title: 'Sample 9s',
                    timecode: '00:00:00:00',
                    instanceDuration: { parsedValue: 9000 },
                    startPlayback: { parsedValue: 0 },
                    priority: { parsedValue: 0 },
                    clip: {
                        id: 'clip_05',
                        name: 'sample-9s.mp3',
                        duration: 9000,
                        url: '/audio/sample-9s.mp3'
                    }
                }
            ]
        },
        auxLayers: [
            {
                id: 'aux_03_01',
                sessionType: 'GUITAR',
                assignedUser: { userId: 'user_mock_03', name: 'Luca', surname: 'Ferrari', profile_picture_url: null },
                volume: 100,
                tracks: [
                    {
                        id: 'aux_03_01_track_01',
                        title: 'Guitar Track',
                        timecode: '00:00:00:00',
                        instanceDuration: { parsedValue: 3000 },
                        startPlayback: { parsedValue: 0 },
                        priority: { parsedValue: 0 },
                        clip: {
                            id: 'clip_06',
                            name: 'sample-3s.mp3',
                            duration: 3000,
                            url: '/audio/sample-3s.mp3'
                        }
                    }
                ]
            }
        ]
    }
];

export default mockRecSessions;
